export const environment = {
  production: false,
  defaultauth: 'fackbackend',
  firebaseConfig: {
    apiKey: '',
    authDomain: '',
    databaseURL: '',
    projectId: '',
    storageBucket: '',
    messagingSenderId: '',
    appId: '',
    measurementId: ''
  },
  // production: false,
  
  // Api: 'http://localhost:2024/nodeapp/', 

  Api: 'https://hmsapi.godavariwave.com/nodeapp/',

  // Api: 'https://hospitalapi.godavariinnovations.com/nodeapp/',


};


